{
  "pages": {
    "listTitle": "Chi phí",
    "recordTitle": "Tạo phiếu chi",
    "categoriesTitle": "Danh mục chi",
    "permissionDenied": "Bạn không có quyền xem chi phí.",
    "categoriesPermissionDenied": "Bạn không có quyền xem danh mục chi.",
    "createPermissionDenied": "Bạn không có quyền ghi nhận chi phí.",
    "updatePermissionDenied": "Bạn không có quyền sửa chi phí."
  },
  "fields": {
    "code": "Mã phiếu",
    "date": "Ngày",
    "category": "Danh mục",
    "description": "Mô tả",
    "method": "Phương thức",
    "amount": "Số tiền",
    "clinic": "Phòng khám",
    "notes": "Ghi chú",
    "recordedBy": "Người ghi nhận",
    "confirmedBy": "Người xác nhận",
    "cancelledBy": "Người hủy",
    "cancelReason": "Lý do hủy",
    "name": "Tên",
    "sortOrder": "Thứ tự",
    "type": "Loại",
    "status": "Trạng thái",
    "expenseDate": "Ngày chi"
  },
  "placeholders": {
    "category": "Chọn danh mục",
    "categoryName": "Ví dụ: Mua vật tư",
    "sortOrder": "Ví dụ: 1",
    "clinic": "Chọn phòng khám",
    "amount": "Nhập số tiền",
    "paymentMethod": "Chọn phương thức",
    "description": "Mua vật tư phòng khám",
    "notes": "Nhập ghi chú",
    "cancelReason": "Nhập lý do hủy phiếu"
  },
  "actions": {
    "recordExpense": "Tạo phiếu chi",
    "record": "Xác nhận",
    "recording": "Đang xác nhận...",
    "saveDraft": "Lưu nháp",
    "savingDraft": "Đang lưu nháp...",
    "saving": "Đang lưu...",
    "viewDetails": "Xem chi tiết chi phí",
    "edit": "Sửa",
    "delete": "Xóa",
    "cancelSlip": "Hủy phiếu",
    "cancelling": "Đang hủy...",
    "addCategory": "Thêm danh mục",
    "history": "Lịch sử"
  },
  "search": {
    "expensePlaceholder": "Tìm theo mã, mô tả...",
    "categoryPlaceholder": "Tìm danh mục..."
  },
  "filters": {
    "trigger": "Bộ lọc",
    "title": "Lọc chi phí",
    "clearAll": "Xóa tất cả",
    "apply": "Áp dụng",
    "dateRange": "Khoảng thời gian",
    "dateRangePlaceholder": "Chọn khoảng ngày",
    "selectCategory": "Chọn danh mục",
    "selectMethod": "Chọn phương thức",
    "selectClinic": "Chọn phòng khám",
    "selectStatus": "Chọn trạng thái",
    "allCategories": "Tất cả danh mục",
    "allMethods": "Tất cả phương thức",
    "allClinics": "Tất cả phòng khám",
    "allStatuses": "Tất cả trạng thái"
  },
  "table": {
    "emptyExpenses": "Không tìm thấy chi phí nào.",
    "emptyCategories": "Chưa có danh mục chi",
    "noCategoryFound": "Không tìm thấy danh mục",
    "createdAt": "Ngày tạo",
    "updatedAt": "Ngày sửa",
    "createdBy": "Người tạo",
    "updatedBy": "Người cập nhật"
  },
  "details": {
    "title": "Chi tiết chi phí",
    "syncedAlert": "Khoản chi này được đồng bộ từ TK nạp trước, Labo, Hoa hồng hoặc Bảng lương. Sửa hoặc xóa tại nguồn gốc."
  },
  "statuses": {
    "draft": "Nháp",
    "recorded": "Xác nhận",
    "cancelled": "Hủy phiếu"
  },
  "categoryType": {
    "system": "Hệ thống",
    "custom": "Tùy chỉnh"
  },
  "categoryStatus": {
    "active": "Đang dùng",
    "inactive": "Ngừng dùng"
  },
  "dialogs": {
    "addCategoryTitle": "Thêm danh mục chi",
    "editCategoryTitle": "Sửa danh mục chi",
    "confirmDeleteExpense": "Xóa bản ghi chi phí này?",
    "cancelTitle": "Hủy phiếu chi",
    "confirmCancel": "Phiếu {{code}} sẽ chuyển sang Hủy phiếu và không còn tính vào tiền. Mã phiếu vẫn giữ."
  },
  "history": {
    "title": "Lịch sử danh mục",
    "empty": "Chưa có thay đổi nào trên mục này."
  },
  "form": {
    "categoryName": "Danh mục chi",
    "amount": "Số tiền",
    "expenseDate": "Ngày chi",
    "paymentMethod": "Phương thức thanh toán",
    "description": "Mô tả",
    "notes": "Ghi chú",
    "editTitle": "Sửa chi phí",
    "save": "Lưu"
  },
  "validation": {
    "categoryNameRequired": "Vui lòng nhập danh mục chi",
    "categoryNameTooLong": "Danh mục chi không quá {{max}} ký tự",
    "sortOrderInvalid": "Thứ tự phải là số từ 0 đến 999999",
    "selectCategory": "Vui lòng chọn danh mục",
    "selectClinic": "Vui lòng chọn phòng khám",
    "validAmount": "Vui lòng nhập số tiền hợp lệ",
    "expenseDateRequired": "Vui lòng chọn ngày chi",
    "paymentMethodRequired": "Vui lòng chọn phương thức thanh toán"
  },
  "toasts": {
    "loadListFailed": "Không tải được danh sách chi phí",
    "loadListError": "Lỗi khi tải chi phí. Vui lòng thử lại.",
    "loadDetailsFailed": "Không tải được chi tiết chi phí.",
    "loadCategoriesFailed": "Không tải được danh mục chi",
    "categoryCreated": "Đã thêm danh mục chi",
    "categoryUpdated": "Đã cập nhật danh mục chi",
    "categorySaveFailed": "Lưu danh mục thất bại",
    "categoryDeactivated": "Đã ngừng dùng danh mục",
    "categoryDeactivateFailed": "Ngừng dùng danh mục thất bại",
    "expenseRecorded": "Đã ghi nhận chi phí",
    "draftSaved": "Đã lưu nháp",
    "expenseUpdated": "Đã cập nhật chi phí",
    "expenseSaveFailed": "Lưu chi phí thất bại",
    "expenseDeleted": "Đã xóa chi phí",
    "expenseDeleteFailed": "Xóa chi phí thất bại",
    "cancelled": "Đã hủy phiếu chi",
    "cancelFailed": "Hủy phiếu chi thất bại"
  },
  "errors": {
    "EXPENSE_CANCEL_REASON_REQUIRED": "Vui lòng nhập lý do hủy",
    "EXPENSE_CANCEL_REASON_TOO_LONG": "Lý do hủy quá dài",
    "EXPENSE_ALREADY_CANCELLED": "Phiếu chi đã được hủy",
    "EXPENSE_STATUS_INVALID": "Không đổi được trạng thái phiếu chi"
  },
  "pagination": {
    "rowsPerPage": "Số dòng mỗi trang:",
    "displayedRows": "{{from}}–{{to}} / {{count}}",
    "moreThan": "hơn {{to}}"
  }
}
